import { JWT_TOKEN, REFRESH_TOKEN, USER_INFO } from "../constants/Constants";
import Cookies from "js-cookie";
import { decodeUserInfo } from "./userInfoEncoding";

export const saveUserInfo = (data) => {
  localStorage.setItem(USER_INFO, data);
};

export const getUserInfo = () =>
  decodeUserInfo(localStorage.getItem(USER_INFO));

export const saveUserToken = (token, expiry) => {
  Cookies.set(JWT_TOKEN, token, {
    domain: getCookieDomainSafe(),
    secure: true,
    sameSite: "Lax",
    // expires: new Date(expiry),
  });
};

export const saveRefreshToken = (token, expiry) => {
  Cookies.set(REFRESH_TOKEN, token, {
    domain: getCookieDomainSafe(),
    secure: true,
    sameSite: "Lax",
    expires: new Date(expiry),
  });
};

export const cookiesCleanup = () => {
  Cookies.remove(JWT_TOKEN, {
    domain: getCookieDomainSafe(),
    path: "/",
  });
  Cookies.remove(REFRESH_TOKEN, {
    domain: getCookieDomainSafe(),
    path: "/",
  });
  localStorage.removeItem(USER_INFO);
};

export const getCookieDomainSafe = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (hostname === "localhost" || parts.length < 2) {
    return hostname;
  }

  return "." + parts.slice(-2).join("."); // e.g., .advancedcompliance.tech
};
